import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { activateUserCode } from '../helpers/activate-user-code';
import { createIdentity } from '../helpers/create-identity';
import { acceptMarketingOffers } from '@sxm-de/dev-kits/web-sdk/domains/agreements';

interface CreateIdentityAndActivateUserCodeFnPayload {
    emailAddress: string;
    marketingConsentVersion: string;
    activationCode?: string;
    locale: string;
}

export type CreateIdentityAndActivateUserCodeFn = (
    payload: CreateIdentityAndActivateUserCodeFnPayload,
) => Promise<unknown>;

export function initCreateIdentityAndActivateUserCodeFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): CreateIdentityAndActivateUserCodeFn {
    return async ({
        emailAddress,
        marketingConsentVersion,
        activationCode,
        locale,
    }: CreateIdentityAndActivateUserCodeFnPayload) => {
        await createIdentity({ emailAddress }, dependencies);
        await acceptMarketingOffers(
            {
                version: marketingConsentVersion,
                language: locale,
                countryCode: countryCodeDefault.toUpperCase(),
            },
            dependencies,
        );

        if (!activationCode) {
            return false;
        } else {
            await activateUserCode({ activationCode }, dependencies);
            return true;
        }
    };
}
